import { render, staticRenderFns } from "./PacketizationDiagram.vue?vue&type=template&id=2b8e531a&"
import script from "./PacketizationDiagram.vue?vue&type=script&lang=ts&"
export * from "./PacketizationDiagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports